<template>
  <div class="section" style="padding: 20px 20px 10px 20px">
    <span class="title">{{ $t('Partners.formatInformation') }}</span>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left" class="form-item-350">
        <el-form-item :label="$t('SeaExport.codeAbbreviation')" class="margin-Right50">
          <cargo-input v-model="form.shortCode" no="shortCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.enterpriseCode')">
          <cargo-input v-model="form.enterpriseCode" no="enterpriseCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
        <br>
        <el-form-item :label="$t('Tool.Name')" class="margin-Right50">
          <cargo-input v-model="form.enterpriseName" no="enterpriseName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
        <el-form-item :disabled="readonly" :label="$t('Partners.detailAddress')">
          <cargo-input v-model="form.address" no="address" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left" class="form-item-350">
        <el-form-item label-width="0" class="form-item-450 margin-Right50">
          <div style="display: flex">
            <el-select v-model="form.contactsType" no="contactsType" style="width:90px">
              <el-option :label="$t('Partners.phone')" :value="0" />
              <el-option :label="$t('Partners.emailAddress')" :value="1" />
              <el-option :label="$t('Partners.relexNumber')" :value="2" />
            </el-select>
            <cargo-input v-model="form.contacts" no="contacts" :auto-uppercase="notUppercaseShipperConsigneNotify" style="width: 350px;margin-left: 10px" />
          </div>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.cityName')">
          <cargo-input v-model="form.cityName" no="cityName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
        <br>
        <el-form-item :label="$t('SeaExport.provinceCode')" class="margin-Right50">
          <cargo-input v-model="form.provinceCode" no="provinceCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.provinceName')">
          <cargo-input v-model="form.provinceName" no="provinceName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left" class="form-item-350">
        <el-form-item :label="$t('SeaExport.ZipCode')" class="margin-Right50">
          <cargo-input v-model="form.zipCode" no="zipCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.countryCode')">
          <cargo-input v-model="form.countryCode" no="countryCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
        <br>
        <el-form-item :label="$t('SeaExport.aeoEnterpriseCode')" class="margin-Right50">
          <cargo-input v-model="form.aeoEnterpriseCode" no="aeoEnterpriseCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.specificContactName')">
          <cargo-input v-model="form.specificContactsName" no="specificContactsName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row" style="padding-top: 0px;">
      <el-form :disabled="readonly" :inline="true" class="form-item-450">
        <el-form-item>
          <div style="display: flex">
            <el-select v-model="form.specificContactsType" no="specificContactsType" style="width:200px">
              <el-option :label="$t('SeaExport.specificContactPhone')" :value="0" />
              <el-option :label="$t('Partners.specificContactEmailAddress')" :value="1" />
              <el-option :label="$t('SeaExport.specificContactRelexNumber')" :value="2" />
            </el-select>
            <cargo-input v-model="form.specificContacts" no="specificContacts" :auto-uppercase="notUppercaseShipperConsigneNotify" style="margin-left: 10px" />
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div style="width: 950px;margin-top: 20px;margin-bottom: 10px">
      <span class="title">{{ $t('Partners.notFormatInformation') }}</span>
      <el-button no="formatSynchronize" :disabled="readonly" type="primary" style="float:right" @click="syncformatToNotFormat">{{ $t('Partners.formatSynchronize') }}</el-button>
    </div>
    <el-form :disabled="readonly" class="form-item-450">
      <el-form-item
        v-for="count in 7"
        :key="'addressLine'+count"
      >
        <cargo-input
          :ref="'addressLine'+count"
          v-model="form['addressLine'+count]"
          :no="'addressLine'+count"
          :filter-chars="false"
          :auto-uppercase="notUppercaseShipperConsigneNotify"
          style="width:450px"
          @dblclick.native="showAddressDialog"
          @change="()=>wrapAddr(form,'addressLine'+count,count+1 > 7 ? null :'addressLine'+(count+1),maxChars)"
        />
      </el-form-item>
    </el-form>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="!readonly" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import { getManifestAddressList } from '@/api/partner/manifestAddress'
import { AutoIncrementNum } from '@/utils/commonUtil'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'ManifestAddressForm',
  components: { CargoRichTextarea, cargoInput },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    const initForm = {
      uuid: '',
      shortCode: '',
      enterpriseCode: '',
      enterpriseName: '',
      address: '',
      contactsType: 0,
      contacts: '',
      cityName: '',
      provinceCode: '',
      provinceName: '',
      zipCode: '',
      countryCode: '',
      aeoEnterpriseCode: '',
      specificContactsName: '',
      specificContactsType: 0,
      specificContacts: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      addressLine4: '',
      addressLine5: '',
      addressLine6: '',
      addressLine7: '',
      companyUuid: ''
    }
    return {
      company: {},
      initForm,
      form: initForm,
      autoIncrementNum: new AutoIncrementNum(),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0, autoUppercase: false, autoHalfWord: false
        }
      },
      maxChars: 255,
      notUppercaseShipperConsigneNotify: true // CARGO-47047 收发通大小写控制
    }
  },
  computed: {
    readonly() {
      return !this.action || this.action === 'look'
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify(cache.config)
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.company = row
        this.getForm()
      }
    },
    async getForm(companyUuid) {
      if (!this.company.manifestAddress) {
        if (this.company.uuid) {
          await getManifestAddressList({ companyUuid: this.company.uuid }).then(res => {
            if (res.data.list.length > 0) {
              this.company.manifestAddress = res.data.list[0]
            }
          })
        }
        if (!this.company.manifestAddress) {
          this.company.manifestAddress = { ...this.initForm, companyUuid: this.company.uuid }
        }
      }
      this.form = this.company.manifestAddress
    },
    syncformatToNotFormat() {
      const form = this.form
      form.addressLine1 = form.enterpriseCode
      form.addressLine2 = form.enterpriseName
      form.addressLine3 = form.address
      let addressLine4 = form.cityName
      if (form.provinceName) {
        if (addressLine4) {
          addressLine4 += ' '
        }
        addressLine4 += form.provinceName
      }
      if (form.countryCode) {
        if (addressLine4) {
          addressLine4 += ' '
        }
        addressLine4 += form.countryCode
      }
      if (form.zipCode) {
        if (addressLine4) {
          addressLine4 += ' '
        }
        addressLine4 += form.zipCode
      }
      form.addressLine4 = addressLine4
      if (form.contacts) {
        switch (form.contactsType) {
          case 0:
            form.addressLine5 = 'TEL:' + form.contacts
            break
          case 1:
            form.addressLine5 = 'EMAIL:' + form.contacts
            break
          case 2:
            form.addressLine5 = 'FAX:' + form.contacts
            break
          default:
            form.addressLine5 = ''
            break
        }
      }
    },
    getSubmitData() {
      return {
        manifestAddress: this.form
      }
    },
    showAddressDialog() {
      this.showAdvanceTextDialog(this.$t('Partners.notFormatInformation'), this.mergeAddressLine(), this.splitAddressLine, this.notUppercaseShipperConsigneNotify, {
        maxChar: 255, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    mergeAddressLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['addressLine' + i] || ''
        result += '\n'
      }
      result += (this.form['addressLine7'] || '')
      return result.trimEnd()
    },
    splitAddressLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['addressLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['addressLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['addressLine' + i] = ''
      }
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
.section {
  .form-item-350 ::v-deep {
    .el-form-item__content {
      width: 350px;
    }
  }
  .form-item-450 ::v-deep {
    .el-form-item__content {
      width: 450px;
    }
  }
  .margin-Right50 {
    margin-right: 50px;
  }
}
</style>
